// Collection smart editor (item 3.4): the page hosts the SHARED
// filterBuilderExtra island (one vocabulary, one engine — the Go
// registry's payload; the builder's Apply delegates here through the
// collectionTreeApply store hook). This module owns only the
// collection-specific write: PUT the tree; the qf engine drives
// membership everywhere. The legacy per-rule page (rule CRUD,
// test-rules preview, match-mode toggle) is retired — legacy rules
// arrays preload as their CONVERTED tree (RulesToFilterTree, rendered
// server-side) and upgrade at the first Apply.

import { authHeaders } from "./storage";
import { Alpine } from "./alpine";
import { showToast } from "./toast";

let collectionId = "";
function initCollectionRules(id: string, _scope: string, _treeJSON: string): void {
  collectionId = id;

  // The builder island emits its APPLY wire through this hook — the
  // page (not the shared component) owns the collection write. The
  // IMPORTED Alpine instance owns the store registry (the bookPicker
  // pattern); window.Alpine is optional-chained elsewhere and may be
  // absent at init timing.
  Alpine.store("collectionTreeApply", {
    hook: async (wire: string) => {
      const name = pageCollectionName();
      if (!name) {
        showToast("Cannot determine the collection name", "error");
        return;
      }
      try {
        const response = await fetch(`/api/collections/${collectionId}`, {
          method: "PUT",
          headers: { ...authHeaders(), "Content-Type": "application/json" },
          body: JSON.stringify({ name, filter_tree: JSON.parse(wire) }),
        });
        if (response.ok) {
          showToast("Smart collection updated", "success");
          window.location.reload();
        } else {
          const body = await response.json().catch(() => ({}));
          showToast(body.error || "Failed to update the collection", "error");
        }
      } catch {
        showToast("Failed to update the collection", "error");
      }
    },
  });
}

function pageCollectionName(): string {
  // The server renders the real name (the page title is presentation,
  // and parsing it would RENAME the collection to "Smart Collection").
  return document.body.dataset.collectionName || "";
}

function backToCollection(): void {
  const path = window.location.pathname; // /collections/:id/rules
  window.location.href = path.replace(/\/rules$/, "");
}

Alpine.data("collectionRules", () => ({
  backToCollection,
  initCollectionRules,
}));
